<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
/* One background and font for every page, so nothing flashes white or
   falls back to Roboto while a page loads. */
html,
body,
#app,
.v-application {
  background: #f7f2ea !important;
}

.v-application {
  font-family: "DM Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
  color: #1d2233;
}

.v-application .v-main {
  padding: 0 !important;
}

::selection {
  background: rgba(178, 58, 51, 0.18);
  color: #1d2233;
}

/* Warm, thin scrollbars */
* {
  scrollbar-color: #d6cab8 #f7f2ea;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: #f7f2ea;
}

::-webkit-scrollbar-thumb {
  background: #d6cab8;
  border-radius: 10px;
  border: 2px solid #f7f2ea;
}

::-webkit-scrollbar-thumb:hover {
  background: #bfb19c;
}

/* Keyboard focus that's visible on every page */
:focus-visible {
  outline: 2px solid #2f4a7a;
  outline-offset: 2px;
}
</style>